import React from 'react';

const Privacy = () => {
  return (
    <div className="policy-page">
    <div className="container">
      <div className="policy-header">
      <h1>Privacy Policy</h1>
<p>Last updated: March 15, 2025</p>

      </div>
  
      <div className="policy-content">
      <div className="policy-section">
  <p>https://nzsocialge.com ("we", "our", or "us") operates the website https://nzsocialge.com (the "Service").</p>
  <p>This page informs you of our policies regarding the collection, use, and disclosure of personal information when you use our Service.</p>
  <p>We do not use or share your information with anyone except as described in this Privacy Policy.</p>
  <p>We use your personal information to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used have the same meanings as in our Terms of Service available at https://nzsocialge.com.</p>

  <h2>Information Collection and Use</h2>
  <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information ("Personal Information") may include, but is not limited to:</p>

  <h2>Log Data</h2>
  <p>We collect information that your browser sends whenever you visit our Service ("Log Data"). This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser type and version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.</p>

  <h2>Cookies</h2>
  <p>Cookies are files with a small amount of data that may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your computer's hard drive.</p>
  <p>We use cookies to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.</p>

  <h2>Service Providers</h2>
  <p>We may employ third-party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Service-related tasks, or to assist us in analyzing how our Service is used.</p>
  <p>These third parties have access to your Personal Information only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</p>

  <h2>Security</h2>
  <p>The security of your Personal Information is important to us, but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.</p>
  <p>We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party websites or services.</p>

  <h2>Children’s Privacy</h2>
  <p>Our Service is not intended for anyone under the age of 18 ("Children").</p>
  <p>We do not knowingly collect personally identifiable information from children under 18. If you are a parent or guardian and you are aware that your child has provided us with Personal Information, please contact us. If we become aware that we have collected Personal Information from a child under age 18, we will delete that information immediately from our servers.</p>

  <h2>Changes to This Privacy Policy</h2>
  <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
  <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>

  <h2>Data Analytics</h2>
  <p>Crazy Monkey Slot Game reserves the right to use your personal information for analytical purposes. This analysis may include user segmentation and profiling to enable more targeted marketing initiatives. These analytical methods and profiling may be automated and may not be manually reviewed by Crazy Monkey Slot Game staff. Such processes may use personal data to infer new details such as financial status, interests, behavioral patterns, online activities, customer loyalty, or location.</p>

  <h2>Contact Us</h2>
  <p>If you have any questions about this Privacy Policy, please contact us.</p>
</div>

      </div>
    </div>
  </div>
  
  );
};

export default Privacy; 